module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [(_vm.store_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._v("lodddi\r\n            "), _c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [_vm._v("\r\n            " + _vm._s(_vm.data_store[0].data) + "\r\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7433afa"}!./src/pages/Boxpoint/Wishlist/template.html
// module id = 498
// module chunks = 0